import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
export var NOTIFICATION_MUTATION = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "mutation",
    "name": {
      "kind": "Name",
      "value": "AddNotification"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "params"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "FullRemoteCustomerInteractionNotificationInput"
          }
        }
      },
      "directives": []
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "addRemoteCustomerInteractionNotification"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "remoteCustomerInteractionNotificationInput"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "params"
            }
          }
        }],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "result"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "backendError"
            },
            "arguments": [],
            "directives": []
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 196,
    "source": {
      "body": "mutation AddNotification($params:FullRemoteCustomerInteractionNotificationInput!){addRemoteCustomerInteractionNotification(remoteCustomerInteractionNotificationInput:$params){result backendError}}",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};
export var notificationMutation = function notificationMutation(remoteCustomerInteractionNotificationInput) {
  return {
    mutation: NOTIFICATION_MUTATION,
    fetchPolicy: 'no-cache',
    variables: {
      params: _Object$assign({}, remoteCustomerInteractionNotificationInput)
    }
  };
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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